import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
export var NOTIFICATION_MUTATION = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "mutation",
    "name": {
      "kind": "Name",
      "value": "AddNotification"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "params"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "FullRemoteCustomerInteractionNotificationInput"
          }
        }
      },
      "directives": []
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "addRemoteCustomerInteractionNotification"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "remoteCustomerInteractionNotificationInput"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "params"
            }
          }
        }],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "result"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "backendError"
            },
            "arguments": [],
            "directives": []
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 196,
    "source": {
      "body": "mutation AddNotification($params:FullRemoteCustomerInteractionNotificationInput!){addRemoteCustomerInteractionNotification(remoteCustomerInteractionNotificationInput:$params){result backendError}}",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};
export var notificationMutation = function notificationMutation(remoteCustomerInteractionNotificationInput) {
  return {
    mutation: NOTIFICATION_MUTATION,
    fetchPolicy: 'no-cache',
    variables: {
      params: _Object$assign({}, remoteCustomerInteractionNotificationInput)
    }
  };
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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